import React from 'react';
import Dropdown from '../../../../../Components/Dropdown/Dropdown';
import { Button } from '../../../../../Components/StyledComponents';
import Switch from '../../../../../Components/Switch/Switch';
import './OperationHour.scss'
import {cloneDeep} from 'lodash-es';

/* ***
Waiting OperationHour 참고
*** */

let hourOptions = []
let minuteOptions = []

const OperationHour = ({info,patchOperationHours}) => {
    const [ everyday, setEveryday ] = React.useState(true);
    const [ weekday, setWeekday ] = React.useState({
        OpenHour : 0,
        OpenMin : 0,
        CloseHour : 0,
        CloseMin : 0,
        Allday : false
    })
    const [ saturday, setSaturday ] = React.useState({
        OpenHour : 0,
        OpenMin : 0,
        CloseHour : 0,
        CloseMin : 0,
        Allday : false
    })
    const [ sunday, setSunday ] = React.useState({
        OpenHour : 0,
        OpenMin : 0,
        CloseHour : 0,
        CloseMin : 0,
        Allday : false
    })

    React.useEffect(() => {
        hourOptions = []
        minuteOptions = []
        for(let i=0;i<=23;i++){
            hourOptions.push({ key : i + '시', value : i})
            if( i < 6 ) minuteOptions.push({ key : i * 10 + '분', value : i * 10 })
        }
        if(typeof info !== 'undefined'){
            setEveryday(cloneDeep(info.Everyday))
            setWeekday(cloneDeep(info.Weekday))
            setSaturday(cloneDeep(info.Saturday))
            setSunday(cloneDeep(info.Sunday))
        }
    },[])

    const patch = () => {
        patchOperationHours({
            Allday : everyday,
            Weekday : weekday,
            Saturday : saturday,
            Sunday : sunday
        })
    }

    return (
        <div className='operation-modal'>
            <div className='row' style={{ marginTop : 24 }}>
                <button className={`${ everyday ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32, width : 153 }} onClick={() => setEveryday(true)}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            everyday ?
                            <img src={require('../../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        주말과 동일해요
                    </div>
                </button>

                <button className={`${ !everyday ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setEveryday(false)} style={{ width : 192 }}>
                    <div className='row' style={{ justifyContent : 'center' }}>
                        {
                            everyday ?
                            <img src={require('../../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            :
                            <img src={require('../../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                        }
                        주말 영업시간은 달라요
                    </div>
                </button>
            </div>

            <div style={{ marginTop : 40 }}>
                <p className='modal-title'>평일</p>

                <div className='row'>
                    <p className='label'>24시간</p>
                    <Switch value={weekday.Allday} id="weekday" onChange={(val) => setWeekday({...weekday,Allday : val})} />
                </div>

                {
                    everyday && !weekday.Allday ? 
                    <div>
                        <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                            <p className='label'>영업시작</p>
                            <Dropdown
                                id='oper-all-starthour'
                                options={hourOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,OpenHour : val})}
                                btnStyle={{ marginRight : 16 }}
                                prefix={'시'}
                                value={weekday.OpenHour}
                            />
                            <Dropdown
                                id='oper-all-startmin'
                                options={minuteOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,OpenMin : val})}
                                value={weekday.OpenMin}
                                prefix={'분'}
                            />
                        </div>

                        <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                            <p className='label'>영업종료</p>
                            <Dropdown
                                id='oper-all-endhour'
                                options={hourOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,CloseHour : val})}
                                value={weekday.CloseHour}
                                btnStyle={{ marginRight : 16 }}
                                prefix={'시'}
                            />
                            <Dropdown
                                id='oper-all-endmin'
                                options={minuteOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,CloseMin : val})}
                                value={weekday.CloseMin}
                                prefix={'분'}
                            />
                        </div>
                    </div>
                    : null
                }
            </div>

            {
                !everyday ?
                <div>
                    <div>
                        <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                            <p className='label'>영업시작</p>
                            <Dropdown
                                id='oper-all-starthour'
                                options={hourOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,OpenHour : val})}
                                btnStyle={{ marginRight : 16 }}
                                prefix={'시'}
                                value={weekday.OpenHour}
                            />
                            <Dropdown
                                id='oper-all-startmin'
                                options={minuteOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,OpenMin : val})}
                                value={weekday.OpenMin}
                                prefix={'분'}
                            />
                        </div>

                        <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                            <p className='label'>영업종료</p>
                            <Dropdown
                                id='oper-all-endhour'
                                options={hourOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,CloseHour : val})}
                                value={weekday.CloseHour}
                                btnStyle={{ marginRight : 16 }}
                                prefix={'시'}
                            />
                            <Dropdown
                                id='oper-all-endmin'
                                options={minuteOptions}
                                width={140}
                                onItemClick={val => setWeekday({...weekday,CloseMin : val})}
                                value={weekday.CloseMin}
                                prefix={'분'}
                            />
                        </div>
                    </div>
                    <div className='divider' />
                    <div>
                        <p className='modal-title'>토요일</p>

                        <div className='row'>
                            <p className='label'>24시간</p>
                            <Switch value={saturday.Allday} id="saturday" onChange={(val) => setSaturday({...saturday,Allday : val})} />
                        </div>

                        {
                            !saturday.Allday ? 
                            <div>
                                <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                                    <p className='label'>영업시작</p>
                                    <Dropdown
                                        id='oper-sat-starthour'
                                        options={hourOptions}
                                        width={140}
                                        onItemClick={val => setSaturday({...saturday,OpenHour : val})}
                                        value={saturday.OpenHour}
                                        btnStyle={{ marginRight : 16 }}
                                        prefix={'시'}
                                    />
                                    <Dropdown
                                        id='oper-sat-startmin'
                                        options={minuteOptions}
                                        width={140}
                                        onItemClick={val => setSaturday({...saturday,OpenMin : val})}
                                        value={saturday.OpenMin}
                                        prefix={'분'}
                                    />
                                </div>

                                <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                                    <p className='label'>영업종료</p>
                                    <Dropdown
                                        id='oper-sat-starthour'
                                        options={hourOptions}
                                        width={140}
                                        onItemClick={val => setSaturday({...saturday,CloseHour : val})}
                                        value={saturday.CloseHour}
                                        btnStyle={{ marginRight : 16 }}
                                        prefix={'시'}
                                    />
                                    <Dropdown
                                        id='oper-sat-endmin'
                                        options={minuteOptions}
                                        width={140}
                                        onItemClick={val => setSaturday({...saturday,CloseMin : val})}
                                        value={saturday.CloseMin}
                                        prefix={'분'}
                                    />
                                </div>
                            </div>
                            : null
                        }
                    </div>
                    <div className='divider' />
                    <div>
                        <p className='modal-title'>일요일</p>

                        <div className='row'>
                            <p className='label'>24시간</p>
                            <Switch value={sunday.Allday} id="sunday" onChange={(val) => setSunday({...sunday,Allday : val})} />
                        </div>

                        {
                            !sunday.Allday ? 
                            <div>
                                <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                                    <p className='label'>영업시작</p>
                                    <Dropdown
                                        options={hourOptions}
                                        width={140}
                                        onItemClick={val => setSunday({...sunday,OpenHour : val})}
                                        value={sunday.OpenHour}
                                        btnStyle={{ marginRight : 16 }}
                                        prefix={'시'}
                                    />
                                    <Dropdown
                                        options={minuteOptions}
                                        width={140}
                                        onItemClick={val => setSunday({...sunday,OpenMin : val})}
                                        value={sunday.OpenMin}
                                        prefix={'분'}
                                    />
                                </div>

                                <div className='row' style={{ marginBottom : 8, marginTop : 16 }}>
                                    <p className='label'>영업종료</p>
                                    <Dropdown
                                        options={hourOptions}
                                        width={140}
                                        onItemClick={val => setSunday({...sunday,CloseHour : val})}
                                        value={sunday.CloseHour}
                                        btnStyle={{ marginRight : 16 }}
                                        prefix={'시'}
                                    />
                                    <Dropdown
                                        options={minuteOptions}
                                        width={140}
                                        onItemClick={val => setSunday({...sunday,CloseMin : val})}
                                        value={sunday.CloseMin}
                                        prefix={'분'}
                                    />
                                    
                                </div>
                            </div>
                            : null
                        }
                    </div>
                </div>
                : null 
            }
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default OperationHour;